export const workOrderServiceMessages = {
  DEFAULT_ERROR: 'Something went wrong',
  GET_WORK_ORDERS_ERROR: 'Unable to load work orders. Please try again.',
  GET_WORK_ORDER_ERROR: 'Unable to load work order. Please try again.',
  CREATE_SUCCESS: 'Work order created',
  EDIT_SUCCESS: 'Work order updated',
  UPLOAD_ERROR: 'Unable to upload attachment. Please try again.',
  SAVE_SETTINGS_ERROR: 'Unable to save work order settings. Please try again.',
};

// Same key per failure, so a retry or a second observer replaces the toast instead of stacking another.
export const workOrderServiceNotificationKeys = {
  GET_WORK_ORDERS_ERROR: 'workOrderServiceGetWorkOrdersError',
  GET_WORK_ORDER_ERROR: 'workOrderServiceGetWorkOrderError',
  CREATE_SUCCESS: 'workOrderServiceCreateSuccess',
};

// S3 key prefix for attachments uploaded from the computer.
export const workOrderUploadPrefix = 'work-orders';
